import React, { useState } from "react";
import Swal from "sweetalert2";
import "../../../assests/css/students/Footer.css";

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = () => {
    if (email) {
      Swal.fire({
        icon: "success",
        title: "Email Submitted Successfully!",
        text: `${email} has been submitted.`,
        confirmButtonColor: "#6a88ce",
        borderRadius: "12px",
      });
      setEmail("");
    }
  };

  return (
    <footer className="ft-footer">
      <div className="ft-footer-container">

        {/* Main Footer Content */}
        <div className="ft-footer-grid">

          {/* ABOUT Section */}
          <div className="ft-footer-section">
            <h3 className="ft-footer-heading">ABOUT</h3>
            <ul className="ft-footer-list">
              <li>
                <a href="#" className="ft-footer-link">About Us</a>
              </li>
            </ul>
          </div>

          {/* CATEGORIES Section */}
          <div className="ft-footer-section">
            <h3 className="ft-footer-heading">CATEGORIES</h3>
            <ul className="ft-footer-list">
              <li>
                <a href="#" className="ft-footer-link">Development</a>
              </li>
            </ul>
          </div>

          {/* SUPPORT Section */}
          <div className="ft-footer-section">
            <h3 className="ft-footer-heading">SUPPORT</h3>
            <ul className="ft-footer-list">
              <li>
                <a href="#" className="ft-footer-link">Documentation</a>
              </li>
            </ul>
          </div>

          {/* GET IN TOUCH Section */}
          <div className="ft-footer-section">
            <h3 className="ft-footer-heading">GET IN TOUCH</h3>
            <p className="ft-footer-text">
              We don't send spam so don't worry.
            </p>

            <div className="ft-email-form">
              <input
                type="email"
                placeholder="Email..."
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="ft-email-input"
              />
              <button
                type="button"
                onClick={handleSubmit}
                className="ft-submit-button"
              >
                Submit
              </button>
            </div>
          </div>

        </div>

        {/* Bottom Section */}
        <div className="ft-footer-bottom">
          <p className="ft-copyright-text">
            © 2025 GGC. All Rights Reserved.
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;